import { z } from "zod";
import {
  phoneNumberSchema,
  phoneNumberOptionalSchema,
} from "../utils/validationUtils";

export const clientCreateSchema = z.object({
  name: z.string().min(1, "Name is required"),
  email: z.string().email("Invalid email"),
  phoneNumber: phoneNumberSchema,
  restaurantName: z.string().optional(),
  screenIds: z.array(z.string()).optional(),
});

export const clientUpdateSchema = z.object({
  name: z.string().min(1, "Name is required").optional(),
  email: z.string().email("Invalid email").optional(),
  phoneNumber: phoneNumberOptionalSchema,
  restaurantName: z.string().optional(),
  screenIds: z.array(z.string()).optional(),
});

export type ClientCreateFormData = z.infer<typeof clientCreateSchema>;
export type ClientUpdateFormData = z.infer<typeof clientUpdateSchema>;

export interface Client {
  id: string;
  name: string;
  email: string;
  phoneNumber: string;
  restaurantName?: string;
  tenantId: string;
  roleId: string;
  createdAt: string;
  updatedAt: string;
  createdBy?: string;
  screenIds?: string[];
  screens?: Array<{ id: string }>;
}
